import React from 'react';
import { List, TextField, BooleanField, FunctionField } from 'react-admin';
import { defaultListProps } from '~constants/config';
import CustomDatagrid from '~components/CustomDatagrid';
import ActionsField from '~components/ActionsField';
import { ROLE_LABELS } from '~utils/permissions';

function UserList({ ...props }) {
  return (
    <List {...defaultListProps} {...props} sort={{ field: 'username', order: 'ASC' }}>
      <CustomDatagrid rowClick="edit">
        <TextField source="username" label="Usuario" />
        <TextField source="firstName" label="Nombre" sortable={false} />
        <TextField source="lastName" label="Apellido" sortable={false} />
        <TextField source="email" label="Email" />
        <FunctionField
          label="Rol"
          sortable={false}
          render={record => (record && ROLE_LABELS[record.role]) || '-'}
        />
        <BooleanField source="isActive" label="Activo" sortable={false} />
        <ActionsField />
      </CustomDatagrid>
    </List>
  );
}

export default UserList;
